const resource = '/v1/works'

export default $axios => ({
  getWorksList(payload) {
    return $axios.get(resource, {params: payload});
  },
  getWorkFromEncryptId(id) {
    return $axios.get(`${resource}/${id}`)
  }
});
